var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58333 8.95833C4.23816 8.95833 3.95833 9.23816 3.95833 9.58333C3.95833 9.92851 4.23816 10.2083 4.58333 10.2083H6.66667C7.01184 10.2083 7.29167 9.92851 7.29167 9.58333C7.29167 9.23816 7.01184 8.95833 6.66667 8.95833H4.58333Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.125 6.25C3.125 5.90482 3.40482 5.625 3.75 5.625H5C5.34518 5.625 5.625 5.90482 5.625 6.25C5.625 6.59518 5.34518 6.875 5 6.875H3.75C3.40482 6.875 3.125 6.59518 3.125 6.25Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91667 12.2917C2.57149 12.2917 2.29167 12.5715 2.29167 12.9167C2.29167 13.2618 2.57149 13.5417 2.91667 13.5417H6.66667C7.01185 13.5417 7.29167 13.2618 7.29167 12.9167C7.29167 12.5715 7.01185 12.2917 6.66667 12.2917H2.91667Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 6.91055C13.4702 6.91055 13.75 6.63073 13.75 6.28555C13.75 5.94038 13.4702 5.66055 13.125 5.66055C12.7798 5.66055 12.5 5.94038 12.5 6.28555C12.5 6.63073 12.7798 6.91055 13.125 6.91055Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 12.9167C16.875 13.2618 16.5952 13.5417 16.25 13.5417C15.9048 13.5417 15.625 13.2618 15.625 12.9167C15.625 12.5715 15.9048 12.2917 16.25 12.2917C16.5952 12.2917 16.875 12.5715 16.875 12.9167Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.15556 2.69751L9.92082 4.19305L11.8943 2.67312C12.04 2.56087 12.2188 2.5 12.4028 2.5H18.75C19.2102 2.5 19.5833 2.8731 19.5833 3.33333V15.3143C19.5833 15.7746 19.2102 16.1477 18.75 16.1477H13.1689L11.8216 16.963C11.6915 17.0417 11.5423 17.0833 11.3902 17.0833H8.4025C8.27981 17.0833 8.15863 17.0562 8.04762 17.004L6.22824 16.1477H0.833333C0.373096 16.1477 0 15.7746 0 15.3143V3.33333C0 2.87309 0.373097 2.5 0.833333 2.5H7.61689C7.81416 2.5 8.00504 2.56999 8.15556 2.69751ZM1.25 14.8977V3.75H7.46411L9.27711 5.28599V15.8333H8.49566L6.67628 14.977C6.56527 14.9248 6.44409 14.8977 6.32139 14.8977H1.25ZM10.5271 15.8333V5.30386L12.5446 3.75H18.3333V14.8977H13.0526C12.9005 14.8977 12.7513 14.9393 12.6212 15.018L11.2739 15.8333H10.5271Z",
    fill: "#333333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryIcon);
export default __webpack_public_path__ + "static/media/storyIcon.3198d1a380d13eafa350c9620f94ac00.svg";
export { ForwardRef as ReactComponent };